module.exports = __webpack_public_path__ + "img/6_152.6a4c114f.png";